import Container from '@/components/Container';
import Spinner from '@/components/Spinner';
import useClientById from '@/hooks/clients/useClientById';
import { useNavigate, useParams } from 'react-router-dom';
import Block from './Block';

type Props = {};

const ClientDetail = (props: Props) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const {
    fullname,
    commercial_name,
    email,
    positionGps,
    phone,
    wilaya,
    commune,
    address,
    tradeRegisterNumber,
    fiscalId,
    statisticalId,
    impositionArticleNumber,
    loading,
  } = useClientById(id as string);

  const googleMapsUrl = `https://www.google.com/maps?q=${positionGps}`;

  if (loading) {
    return (
      <Container>
        <div className='h-screen flex items-center justify-center'>
          <Spinner />
        </div>
      </Container>
    );
  }
  return (
    <Container>
      <div className='flex flex-col gap-4 px-4 py-8'>
        <h1 className='font-semibold text-[22px]'>Client Details</h1>

        <div className='flex flex-col gap-4'>
          {/* client information */}
          <div className='flex flex-col gap-2'>
            <h2 className='text-primary font-semibold text-[16px]'>
              Client information
            </h2>
            <div className='grid grid-cols-5 gap-8'>
              <Block title='Full Name' content={commercial_name} />
              <Block title='Phone' content={phone} />
              <div className='flex flex-col gap-1'>
                <h2 className='text-muted-foreground font-normal text-[16px]'>
                  Location:
                </h2>
                <a
                  target='_blank'
                  rel='noopener noreferrer'
                  href={googleMapsUrl}
                  className='truncate pr-8 font-normal underline text-primary text-[16px] cursor-pointer'
                >
                  {positionGps}
                </a>
              </div>
              <Block title='Wilaya' content={wilaya} />
              <Block title='Commune' content={commune} />
              <Block title='Address' content={address} />
              <Block title='Contact' content={''} />
            </div>
          </div>
          {/* billing information */}
          <div className='flex flex-col gap-2'>
            <h2 className='text-primary font-semibold text-[16px]'>
              Billing information
            </h2>
            <div className='grid grid-cols-4 gap-8'>
              <Block
                title='Trade register number'
                content={tradeRegisterNumber}
              />
              <Block title='Fiscal identification number' content={fiscalId} />
              <Block
                title='Statistical identification number'
                content={statisticalId}
              />
              <Block
                title='Imposition article number'
                content={impositionArticleNumber}
              />
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ClientDetail;
